// extracted by mini-css-extract-plugin
module.exports = {"tableDetail":"ReportForm_tableDetail__3_YAX","stickyFooter":"ReportForm_stickyFooter__685ha","dragMenu":"ReportForm_dragMenu__3tARD","draggable":"ReportForm_draggable__kPqpI"};